import React, { useState } from 'react';
import './input.css';
import { isValidPhoneNumber } from 'libphonenumber-js';

const InputField = ({ label, placeholder, type, onChange, paddingBottom, maxlength, countryCode,validatePhone = false, value,}) => {
  const [focused, setFocused] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const handleChange = (event) => {
    const value = event.target.value;

    // Validate phone number on each change
    if (type === 'number' && validatePhone) {
      const valid = isValidPhoneNumber(value, countryCode);
      setIsValid(valid);
    } else {
      setIsValid(true); // reset isValid if no validation is required
    }

    // Call the onChange callback
    onChange(value);
  };

  return (
    <div>
      <label className={focused ? 'label-input focused' : 'label-input'}>
        {label}
      </label>
      <input
        type={type}
        onChange={handleChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        maxLength={maxlength}
        value={value}            
        className={`input-feild-custom ${!isValid ? 'invalid' : ''}`}
        style={{
          borderBottom: '1px solid white',
          paddingBottom: paddingBottom || '10px',
        }}
      />
      {!isValid && type === 'number' && validatePhone && (
        <p className="error-message">Invalid phone number</p>
      )}
    </div>
  );
};

export default InputField;
